import { useLayoutEffect, useState } from "react";
import Text from "consumer/custom/text"
import Radio from "consumer/custom/radio"
import Select from "consumer/custom/select"
import Address from "consumer/apply/step3/address"
import Agree from "consumer/apply/step3/agree/agree"
import Enroll from "consumer/apply/step3/enroll"
import managerStyle from "manager/manager.module.css"
import { useOffcanvas } from "offcanvas/provider"
import { convert_grade_list } from "consumer/@@@/convert_grade_list"
import Axios from "axios"


export default function Consumer() {

    const { offcanvas_close } = useOffcanvas()

    const selectEevent = window.EventManager.selectEevent
    const branchInfo = window.EventManager.branchInfo

    const searchYear = window.EventManager.searchYear
    const searchMonth = window.EventManager.searchMonth

    const gradeList = window.EventManager.gradeList
    const monthSchedule = window.EventManager.monthSchedule

    const verifyCheck = 1

    const [gradeOption, Set_gradeOption] = useState([])
    const [enrollCheck, Set_enrollCheck] = useState(false)
    const [onlyEnrolled, Set_onlyEnrolled] = useState(false)

    const [scheduleList, Set_scheduleList] = useState([])

    useLayoutEffect(() => {
        const new_schedule_list = []
        for(let i=0; i<monthSchedule.length; i++) {
            new_schedule_list.push({
                name: `${monthSchedule[i]['targetDate']} ${monthSchedule[i]['targetTime']}`,
                value: monthSchedule[i]['id'],
                day: monthSchedule[i]['targetDate'],
                time: monthSchedule[i]['targetTime']
            })
        }
        new_schedule_list.sort((a, b) => a['day'].replaceAll("-", "") - b['day'].replaceAll("-", ""))
        Set_scheduleList(new_schedule_list)
    }, [selectEevent, searchYear, searchMonth])

    async function select_schedule(props) {
        const schedule_info = props['schedule_info']
        if(schedule_info === undefined) {
            Set_gradeOption([])
        }
        else {
            const grade = JSON.parse(schedule_info["targetGrades"])
            const new_grade = await convert_grade_list({
                grade: grade,
                gradeList: gradeList,
            });

            Set_gradeOption(new_grade)
        }
    }

    async function apply() {
        const payload = {}
        const field = document.querySelectorAll('[category="field"]:required')
        for(let i=0; i<field.length; i++) {
            const name = field[i]['name']
            const value = field[i]['value'].trim()
            const error = field[i].getAttribute('error')
            if(value === '') {
                return alert(error)
            }

            payload[name] = value
        }

        const field2 = document.querySelectorAll('[category="field"]:not([required])')
        for(let i=0; i<field2.length; i++) {
            const name = field2[i]['name']
            const value = field2[i]['value'].trim()

            payload[name] = value
        }

        if(window.confirm('등록하겠습니까?')) {
            const result = await Axios
                            .post('/schedule/consumer/save', {
                                data: payload
                            })
            const data = result['data']
            alert(data['message'])
        }
    }

    return(
        <div
            id="step3"
            style={{
                display: "flex",
                flexDirection: "column",
                position: "relative",
                width: "100%",
                height: "100%"
            }}
        >
            <input type="hidden" name="branch_id" value={branchInfo['id']}></input>

            <div
                style={{
                    position: "relative",
                    width: "100%",
                    height: "calc(100% - 70px)",
                    overflowX: "hidden",
                    overflowY: "auto"
                }}
            >
                <Select
                    label="일정"
                    name="schedule_id"
                    option={[
                        {
                            name: "선택",
                            value: "",
                        },
                        ...scheduleList,
                    ]}
                    required={true}
                    error="일정을 선택해 주세요."
                    event={{
                        onChange: function(e) {
                            const check = monthSchedule.find(x => String(x['id']) === String(e.currentTarget.value))
                            select_schedule({
                                schedule_info: check
                            })
                        }
                    }}
                ></Select>

                <Text
                    label="학생 이름"
                    name="student_name"
                    max={10}
                    error="학생 이름을 입력해 주세요."
                    disabled={enrollCheck}
                    required={true}
                    event={{
                        onInput: function (e) {
                            const value = e.currentTarget.value;
                            e.currentTarget.value = value.replace(" ", "");
                        },
                    }}
                ></Text>

                <Text
                    label="보호자 연락처"
                    name="parent_phone"
                    max={11}
                    placeholder="－없이 입력해 주세요."
                    error="보호자 연락처를 입력해 주세요."
                    required={true}
                    event={{
                        onInput: function (e) {
                            const value = e.currentTarget.value;
                            e.currentTarget.value = value.replace(/[^0-9]/g, "");
                        },
                    }}
                ></Text>

                <Enroll
                    gradeOption={gradeOption}
                    verifyCheck={verifyCheck}
                    enrollCheck={enrollCheck}
                    Set_enrollCheck={Set_enrollCheck}
                    onlyEnrolled={onlyEnrolled}
                ></Enroll>

                <Radio
                    label="학생 성별"
                    name="student_sex"
                    list={[
                        {
                            name: "남",
                            value: 1,
                        },
                        {
                            name: "여",
                            value: 0,
                        },
                    ]}
                    required={true}
                    error="학생 성별을 선택해 주세요."
                ></Radio>

                <Select
                    label="학생 학년"
                    name="student_grade"
                    option={[
                        {
                            name: "선택",
                            value: "",
                        },
                        ...gradeOption,
                    ]}
                    required={true}
                    error="학생 학년을 선택해 주세요."
                ></Select>

                <Address></Address>

                <Agree
                    set="promotion"
                    name="promotion"
                    required={false}
                ></Agree>
            </div>

            <div
                style={{
                    position: "relative",
                    width: "100%",
                    height: "70px"
                }}
            >
                <button
                    type="button"
                    className={`
                        ${managerStyle['button']}
                        ${managerStyle['primary']}
                    `}
                    style={{
                        width: "100%",
                        height: "30px",
                        marginBottom: "10px"
                    }}
                    onClick={() => apply()}
                >등록</button>

                <button
                    type="button"
                    className={`
                        ${managerStyle['button']}
                        ${managerStyle['secondary']}
                    `}
                    style={{
                        width: "100%",
                        height: "30px"
                    }}
                    onClick={offcanvas_close}
                >닫기</button>
            </div>
        </div>
    )
}